import { Injectable } from '@angular/core';
import { apis, controllerTypes } from '@sb-shared/models/request-settings';
import { Observable } from 'rxjs';
import { HttpWebApiService } from './http-web-api.service';
import { BackgroundOption } from '@sb-shared/models/UI/background-option';

@Injectable({
  providedIn: 'root'
})
export class VideoBackgroundService {
  constructor(private http: HttpWebApiService) {
    // Constructor logic if needed
  }

  getBackgroundOptions(): Observable<BackgroundOption[]> {
    return this.http.get('VideoBackgroundOption', { controllerType: controllerTypes.User, api: apis.Core });
  }
}
